import './styles/attachments.scss';
import {AttachmentsForRender, AttachmentsPanelProps} from "types/attachment";
import {useSelector} from "react-redux";
import {isDocumentPreviewDetached} from "components/store/application.reducers";
import NewCollapsableTabsComponent from "components/taskdetails-remake/panels/attachments/NewCollapsableTabs.component";
import React, {useRef, useState} from "react";
import AttachmentRenderer from "components/taskdetails-remake/panels/attachments/AttachmentRenderer";
import BypassCIRSkeleton from "components/taskdetails-remake/panels/attachments/BypassCIR.Skeleton";
import {Store} from "redux";
import * as reduxSelectors from "components/store/application.reducers";
import MinMaxGroup from "components/taskdetails-remake/panels/attachments/MinMaxGroup";
import "components/taskdetails-remake/panels/attachments/styles/bypassCIR.scss";
import DownloadButtons
    from "components/taskdetails-remake/panels/attachments/attachmentTypes/Images/DownloadButtons.component";

const AttachmentsPanel = (props: AttachmentsPanelProps) => {
    const isPreviewDetached = useSelector(isDocumentPreviewDetached);


    const attachments: Array<AttachmentsForRender> = useSelector((store: Store) => reduxSelectors.getTaskAttachmentsForRender(store));
    const tabsRefs = useRef<(HTMLDivElement | null)[]>([]);
    let selectedDocument = useSelector((store: Store) => reduxSelectors.getSelectedDocument(store));
    let activeTab: number | null = selectedDocument.index;

    const localStorageValue = window.localStorage.getItem(`@@attinfo/is-panel-collapsed`) ? window.localStorage.getItem(`@@attinfo/is-panel-collapsed`).toLowerCase() === "true" : true;
    const [isPanelCollapsed, setIsPanelCollapsed] = useState<boolean>(localStorageValue);

    const uid = props.taskDetails?.uid || null;
    const docVersion = props.taskDetails.documentVersion;

    const setActiveTab = (value: number) => {
        tabsRefs.current.forEach((ref, i) => {
            if (!ref) return;
            activeTab = value;
            ref.classList.toggle('active', value === i);
            ref.classList.toggle('hidden', value !== i);
        });
    }

    const collapseCallback = () => {
        window.localStorage.setItem(`@@attinfo/is-panel-collapsed`, !isPanelCollapsed);
        setIsPanelCollapsed(!isPanelCollapsed);
    }

    const tabContent: React.ReactElement[] | React.ReactElement = attachments && Array.isArray(attachments) ? attachments.map((attachment: AttachmentsForRender, index: number) => {
        return activeTab === index ? <div
            className={`attachments-preview-modal__tab-content ${(activeTab === index) ? "active" : "hidden"}`}
            ref={ref => tabsRefs.current[index] = ref}
            role="tabpanel"
            aria-labelledby="selected-tab"
            key={`${attachment.id}_tab-pane`}
            aria-hidden={index === activeTab ? "false" : "true"}>

            <AttachmentRenderer attachment={attachment}
                                uid={uid}
                                docVersion={docVersion}
                                ownerDocument={props.ownerDocument}
                                isPanelCollapsed={isPanelCollapsed}
                                collapseCallback={collapseCallback}/>
        </div> : <div key={"not-active-tab_" + index}></div>;
    }) : <div key={"no-items"}></div>;


    if (!attachments || !Array.isArray(attachments) || attachments.length === 0) return (
        <div data-cy="taskDetail.attachmentsPanel"><BypassCIRSkeleton/></div>);
    if (attachments?.length === 1)
        return (<div className={`bg-white p-0 attachments-preview-modal__no-tab-content grid-attachments-preview`}
                     data-testid={"__tst_no_tabs"}
                     style={{width: props.width + "px"}}
                     data-cy="taskDetail.attachmentsPanel">
            <div className={"no-tabs__wrap rounded-4 grid-panel h-100"}>
                <div
                    className="grid-panel-header attachments-panel-header d-flex align-items-center justify-content-between">
                    <strong>
                        {props.translate("taskDetail.panels.attachments.attachmentViewer")}
                    </strong>

                    <div className="w-50 min-max-btn-group d-flex justify-content-end">
                        <DownloadButtons/>
                        {!isPreviewDetached && <MinMaxGroup
                            isAttachmentPanelWidthDefault={props.isAttachmentPanelWidthDefault}
                            isAttachmentPanelMaxWidth={props.isAttachmentPanelMaxWidth}
                            maximizePanel={props.maximizePanel}
                            minimizePanel={props.minimizePanel}
                        />}
                    </div>
                </div>
                <AttachmentRenderer attachment={attachments[0]}
                                    ownerDocument={props.ownerDocument}
                                    isPanelCollapsed={isPanelCollapsed}
                                    uid={uid}
                                    docVersion={docVersion}
                                    collapseCallback={collapseCallback}/>

            </div>
        </div>);


    return (
        <div
            className={`p-0 grid-attachments-preview ${isPreviewDetached ? "detached-height w-100" : ""}`}
            style={{width: props.width + "px"}}
            data-cy="taskDetail.attachmentsPanel">
            <div className={"bg-white px-4 border-radius-top-4"}>
                <div
                    className="grid-panel-header attachments-panel-header d-flex align-items-center justify-content-between">
                    <strong>
                        {props.translate("taskDetail.panels.attachments.attachmentViewer")}
                    </strong>
                    <div className="w-50 min-max-btn-group d-flex justify-content-end">
                        <DownloadButtons/>
                        {!isPreviewDetached && <MinMaxGroup
                            isAttachmentPanelWidthDefault={props.isAttachmentPanelWidthDefault}
                            isAttachmentPanelMaxWidth={props.isAttachmentPanelMaxWidth}
                            maximizePanel={props.maximizePanel}
                            minimizePanel={props.minimizePanel}
                        />}
                    </div>
                </div>
                <div className={`w-100 attachments-panel__tabs-wrap`}>
                    <NewCollapsableTabsComponent attachments={attachments}
                                                 activeTab={activeTab}
                                                 setActiveTab={setActiveTab}/>
                </div>
            </div>
            <div className={"grid-panel-content attachments-preview-modal"}>
                {tabContent}
            </div>

        </div>
    );
}

export default AttachmentsPanel;